export enum FieldContext {
  PRIOR_VALUE = 'PRIOR_VALUE',
  CURRENT_VALUE = 'CURRENT_VALUE',
  ACTION_RESULT = 'ACTION_RESULT',
}
